const PREFIX = 'OPERATION_LOG_SDK'

export default {
  PARAM_TYPE_ERROR_CODE: `${PREFIX}/PARAM_TYPE_ERROR`,
  UNIQUE_EVENT_NOT_FOUND_ERROR_CODE: `${PREFIX}/UNIQUE_EVENT_NOT_FOUND_ERROR`
}
